// Utilidades simples de gating de registro por pago (client-side)
// Nota: Esto es un soft-gate. Para entorno productivo, validar pago en backend con webhooks.

export const PAID_KEY = 'ws_paid';
export const BLOCK_BASIC_KEY = 'ws_block_basic';

export function markPaid(source, plan, ref) {
  try {
    const payload = { source, plan, ref: ref || null, ts: Date.now() };
    localStorage.setItem(PAID_KEY, JSON.stringify(payload));
    return true;
  } catch (_) {
    return false;
  }
}

export function isPaid() {
  try {
    const raw = localStorage.getItem(PAID_KEY);
    if (!raw) return false;
    const obj = JSON.parse(raw);
    if (!obj || !obj.ts) return false;
    // Ventana de validez corta para registro: 2 horas
    const MAX_AGE = 2 * 60 * 60 * 1000; // 2h
    if (Date.now() - obj.ts > MAX_AGE) return false;
    return true;
  } catch (_) {
    return false;
  }
}

export function clearPaid() {
  try { localStorage.removeItem(PAID_KEY); } catch(_) {}
}

// Marca que el plan básico ($7/7días) no puede volver a comprarse
export function blockBasicForever() {
  try { localStorage.setItem(BLOCK_BASIC_KEY, '1'); } catch(_) {}
}

// Verifica si el plan básico está bloqueado para este dispositivo/navegador
export function isBasicBlocked() {
  try { return localStorage.getItem(BLOCK_BASIC_KEY) === '1'; } catch(_) { return false; }
}
